import { render, staticRenderFns } from "./test-edit.vue?vue&type=template&id=586e1f10&scoped=true&"
import script from "./test-edit.vue?vue&type=script&lang=js&"
export * from "./test-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e1f10",
  null
  
)

export default component.exports